/* eslint-disable @typescript-eslint/ban-ts-comment */

import * as React from 'react';

import { useSlug } from '../hooks/useSlug';
import { GlobalProps, InputProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type InputLabelProps = GlobalProps & {
  bottom?: boolean;
  children?: React.ReactNode;
  labelProps?: InputProps<HTMLLabelElement>;
  className?: string;
  error?: boolean;
  htmlFor?: string;
  label?: string;
  size?: 'small' | 'default' | 'large';
  spanClassName?: string;
};

export const InputLabel = React.forwardRef<HTMLLabelElement, InputLabelProps>(
  function InputLabelComponent(props, ref) {
    const {
      bottom = true,
      children,
      className,
      error = false,
      labelProps = {},
      htmlFor,
      label,
      name = 'label',
      size = 'default',
      spanClassName,
    } = props;

    const slugName = useSlug(name);
    const cx = classes(
      [
        className,
        styles.label,
        styles[size],
        {
          [styles.alert]: error,
        },
      ],
      props
    );

    const cy = classes([spanClassName], {
      ...props,
      name: `${name}-inner`,
    });

    // disabling rule below, as we actually DO follow it
    // by rendering the input INSIDE the label

    // however, eslint is unable to detect this
    /* eslint-disable jsx-a11y/label-has-associated-control */
    return (
      <label
        className={cx}
        htmlFor={htmlFor}
        data-component={slugName}
        ref={ref}
        style={{
          // @ts-ignore
          '--accent-color': 'currentColor',
        }}
        {...labelProps}
      >
        {!bottom && <span className={cy}>{label}</span>}
        {children}
        {bottom && <span className={cy}>{label}</span>}
      </label>
    );
  }
);
